import { defineStore } from 'pinia'

type State = {
  loading: boolean
  error: any
}

export const useRequestStateStore = defineStore('requestState', {
  state: (): State => {
    return {
      loading: false,
      error: null
    }
  }
})
